const mapPayment = (payment, paymentIndex, operation) => ({ ...payment, paymentIndex, operationId: operation._id, type: operation.type });

export const debtToCreditList = debt => {
  if (debt.length === 0) {
    return [];
  }
  return debt.reduce((acc, opIn) => {
    const operation = JSON.parse(JSON.stringify(opIn));
    if (operation.type === 'COMPLEMENTARY') {
      const mortgageIsPresent = debt.some(op => operation.mortgageOperationId === op._id);
      if (!mortgageIsPresent) {
        acc.push({
          complementaryOperation: operation,
          complementaryOperationId: operation._id,
          _id: operation.mortgageOperationId,
          clientId: operation.clientId,
          allPayments: operation.payments.map((p, i) => ({ complementaryPayment: mapPayment(p, i, operation) })),
          isActive: operation.isActive
        });
      }
      return acc;
    }
    // Si es un hipotecario
    // Busco su complementario (será undefined si no existe)
    operation.complementaryOperation = debt.find(op => operation.complementaryOperationId === op._id);
    // Obtengo las cuotas hipotecarias y complementarias
    const mortgagePayments = operation.payments.map((p, i) => mapPayment(p, i, operation));
    const complementaryPayments = operation.complementaryOperation ? operation.complementaryOperation.payments.map((p, i) => mapPayment(p, i, operation.complementaryOperation)) : [];
    // Construye pares de pagos
    const allPayments = mortgagePayments.reduce((pairs, payment) => {
      const pair = { mortgagePayment: payment };
      // const complementaryPaymentPairIndex = complementaryPayments.findIndex(p => p.paymentNumber === payment.paymentNumber);
      const complementaryPaymentPairIndex = complementaryPayments.findIndex(p => p.dueDate === payment.dueDate);
      if (complementaryPaymentPairIndex >= 0) {
        pair.complementaryPayment = complementaryPayments[complementaryPaymentPairIndex];
        complementaryPayments.splice(complementaryPaymentPairIndex, 1);
      }
      pairs.push(pair);
      return pairs;
    }, []);
    // Si queda una cuota del complementario sin recorrer, la agrega
    if (complementaryPayments.length > 0) {
      const pendingComplementaryPayments = complementaryPayments.map(p => ({ complementaryPayment: p }));
      // if (complementaryPayments[0].paymentNumber < allPayments[0].mortgagePayment.paymentNumber) {
      if (complementaryPayments[0].dueDate < allPayments[0].mortgagePayment.dueDate) {
        allPayments.unshift(...pendingComplementaryPayments);
      } else {
        allPayments.push(...pendingComplementaryPayments);
      }
    }
    // Guarda el arreglo de cuotas
    operation.allPayments = allPayments.sort((a, b) => {
      // const aPaymentNumber = (a.mortgagePayment || a.complementaryPayment).paymentNumber;
      // const bPaymentNumber = (b.mortgagePayment || b.complementaryPayment).paymentNumber;
      const aPaymentNumber = (a.mortgagePayment || a.complementaryPayment).dueDate;
      const bPaymentNumber = (b.mortgagePayment || b.complementaryPayment).dueDate;
      if (aPaymentNumber < bPaymentNumber) {
        return -1;
      }
      if (aPaymentNumber > bPaymentNumber) {
        return 1;
      }
      return 0;
    });

    acc.push(operation);
    return acc;
  }, []);
};

/**
 * Este método convierte cualquier objeto recibido en un string base 64
 * @param {object} object
 * @returns string
 */
export const convertObjectToBase64 = object => Buffer.from(JSON.stringify(object)).toString('base64');
